module.exports = __webpack_public_path__ + "static/media/ralph.c3cf8255.jpg";